import React, { Component } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Snackbar, Alert } from '@mui/material';
import { GridTable } from '../Sidebar/SidebarStyles';
import { promises } from 'dns';
import { getAllLobs, getAllChecklistTemplate, getQuestionsById, updateQuestionConfigData, addQuestionConfigData, activateOrDeactivateQConfig } from '../ApiSevices/QuestionConfigService';
import { getbroker } from '../ApiSevices/UserMasterApis';
import { Autocomplete, TextField } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { green, red } from '@mui/material/colors';
import CheckIcon from '@mui/icons-material/Check';

interface IProps {
    displaysidebar: boolean;
}

interface IState {
    templateMaster: any[],
    lobMaster: any[],
    brokerMaster: any[],
    questionConfigData: any[],
    loading: boolean,
    selectedBrokerId: number,
    selectedTemplateId: number,
    selectedLobId: number,
    isDialogOpen: boolean,
    dialogData: any,
    confirmDialog: boolean,
    iconData: any,
    snackbarOpen: boolean,
    snackbarMessage: string,
    snackbarSeverity: 'success' | 'error';
}

const paginationModel = { page: 0, pageSize: 5 };

const columns: GridColDef[] = [
    { field: 'Id', headerName: 'Id', width: 70 },
    { field: 'CoverageSpecificationMaster', headerName: 'CoverageSpecificationMaster', width: 350 },
    { field: 'ChecklistQuestion', headerName: 'ChecklistQuestion', width: 350 },
    { field: 'OrderId', headerName: 'OrderId', width: 100 },
    { field: 'IsActive', headerName: 'Status', width: 100 },
    { field: 'Action', headerName: 'Action', width: 100 }
];

class QuestionConfigMaster extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            templateMaster: [],
            lobMaster: [],
            brokerMaster: [],
            questionConfigData: [],
            selectedBrokerId: 0,
            selectedTemplateId: 0,
            selectedLobId: 0,
            isDialogOpen: false,
            confirmDialog: false,
            iconData: null,
            snackbarOpen: false,
            snackbarSeverity: "success",
            snackbarMessage: "",
            dialogData: {
                CoverageSpecificationMaster: '',
                ChecklistQuestions: '',
            },
        }
    }

    async componentDidMount(): Promise<void> {
        try {
            this.setState({ loading: true });
            const [lobResponse, templateResponse, brokerResponse] = await Promise.all([
                getAllLobs(),
                getAllChecklistTemplate(),
                getbroker()
            ]);

            let sortStaticArry = brokerResponse?.sort((a: any, b: any) => a?.vchBrokerName.localeCompare(b?.vchBrokerName))
            let brokerMasterAltered = sortStaticArry?.map((e: any) => { return { label: e?.vchBrokerName, value: e?.Broker_ID } });
            brokerMasterAltered = brokerMasterAltered?.filter((f: any) => f?.value !== 0)

            let sortStemplateResArry = templateResponse?.sort((a: any, b: any) => a?.VCH_CHECKLIST.localeCompare(b?.VCH_CHECKLIST))
            let templateMasterAltered = sortStemplateResArry?.map((e: any) => { return { label: e?.VCH_CHECKLIST, value: e?.ID } });
            templateMasterAltered = templateMasterAltered?.filter((f: any) => f?.value !== 0)

            let lobMasterAltered = lobResponse?.map((e: any) => { return { label: e?.Actual_LOB_Master, value: e?.ActualLOBID } });
            lobMasterAltered = lobMasterAltered?.filter((f: any) => f?.value !== 0)

            this.setState({
                lobMaster: lobMasterAltered,
                templateMaster: templateMasterAltered,
                brokerMaster: brokerMasterAltered
            });
        } catch (error) {
            console.log(error);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    async getQuestionConfig(): Promise<void> {
        this.setState({ loading: true });
        try {
            const response = await getQuestionsById(
                this?.state?.selectedBrokerId,
                this?.state?.selectedTemplateId,
                this?.state?.selectedLobId);
            this.setState({ questionConfigData: response });
        } catch (error) {
            this.setState({ questionConfigData: [] });
        }
        finally {
            this.setState({ loading: false });
        }
    }

    handleDialogOpen = () => {
        this.setState({ isDialogOpen: true });
    };

    handleDialogClose = () => {
        this.setState({
            isDialogOpen: false,
            dialogData: {
                CoverageSpecificationMaster: '',
                ChecklistQuestions: '',
            },
        });
    };

    handleDialogConfirm = () => {
        const { dialogData } = this.state;
        console.log('Dialog Confirmed with Data:', dialogData);

        this.addNewQuestionConfig(dialogData);
        this.handleDialogClose();
    };

    handleInputChange = (field: string, value: string) => {
        this.setState((prevState) => ({
            dialogData: {
                ...prevState.dialogData,
                [field]: value,
            },
        }));
    };

    addNewQuestionConfig = async (data: { CoverageSpecificationMaster: string; ChecklistQuestions: string }) => {
        try {
            const { selectedLobId, selectedTemplateId, selectedBrokerId } = this.state;
            this.setState({ loading: true });
            const body = {
                "brokerId": selectedBrokerId,
                "templateId": selectedTemplateId,
                "lobId": selectedLobId,
                "coverageSpecificationMaster": data.CoverageSpecificationMaster,
                "checklistQuestion": data.ChecklistQuestions
            }
            await addQuestionConfigData(body);
            this.getQuestionConfig();
            this.setState({
                snackbarMessage: "Added Successfully",
                snackbarOpen: true,
                snackbarSeverity: "success"
            });
        } catch (error) {
            console.log(error);
            this.setState({
                snackbarMessage: "something went wrong",
                snackbarOpen: true,
                snackbarSeverity: "error"
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    };

    onUpdateClick = async () => {
        try {
            this.setState({ loading: true });
            const { questionConfigData } = this.state;
            const selectedRows = questionConfigData.filter(e => e.isSelected);

            const requiredKeys = ['OrderId', 'ChecklistQuestion', 'CoverageSpecificationMaster'];

            // Collect IDs of rows with empty or missing values
            const invalidRows = selectedRows.filter(item =>
                requiredKeys.some(key => !item[key] || item[key].toString().trim() === '')
            );

            if (invalidRows.length > 0) {
                invalidRows.forEach(row => console.log(row.id));
                this.setState({
                    snackbarMessage: "Some records are not filled for these Ids " + invalidRows.map(e => e.Id).toString(),
                    snackbarOpen: true,
                    snackbarSeverity: "error"
                });
                return; // Stop further execution
            }

            const body = selectedRows.map((e: any) => ({
                "id": e.Id,
                "coverageSpecificationMaster": e?.CoverageSpecificationMaster,
                "checklistQuestion": e?.ChecklistQuestion,
                "orderId": e?.OrderId
            }));
            if (body.length > 0) {
                await updateQuestionConfigData(body);
                this.setState({
                    snackbarMessage: "Updated Successfully",
                    snackbarOpen: true,
                    snackbarSeverity: "success"
                });
            }
            this.getQuestionConfig();
        } catch (error) {
            console.log(error);
            this.setState({
                snackbarMessage: "something went wrong",
                snackbarOpen: true,
                snackbarSeverity: "error"
            });
        } finally {
            this.setState({ loading: false });
        }
    }

    handleCloseConfirmDialog = () => {
        this.setState({ confirmDialog: false });
    };

    handleActivate = async (row: any) => {
        try {
            this.setState({ loading: true });
            const body = {
                "ids": [
                    row.Id
                ],
                "status": !row.IsActive
            }
            await activateOrDeactivateQConfig(body);
            this.setState({
                snackbarMessage: (row.IsActive ? "Deactivated" : "Activated") + " successfully.",
                snackbarOpen: true,
                snackbarSeverity: "success",
            });
            this.getQuestionConfig();
        } catch (error) {
            console.log(error);
            this.setState({
                snackbarMessage: "something went wrong",
                snackbarOpen: true,
                snackbarSeverity: "error",
            });
            this.handleCloseConfirmDialog();
        } finally {
            this.setState({
                loading: false,
                confirmDialog: false
            });
        }
    }
    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    }

    render() {
        const {
            loading, templateMaster, lobMaster, brokerMaster, selectedBrokerId,
            selectedTemplateId, selectedLobId, questionConfigData, isDialogOpen, dialogData, confirmDialog, iconData, snackbarMessage, snackbarOpen, snackbarSeverity
        } = this.state;
        const isConfirmEnabled = dialogData?.CoverageSpecificationMaster?.trim() !== '' && dialogData?.ChecklistQuestions?.trim() !== '';
        return (
            <div style={{ fontSize: "12px" }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable sx={{ height: '90vh' }} displaysidebar={this?.props?.displaysidebar}>
                    <p><b>Question Configuration Master</b></p><br />
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%"
                    }}>
                        {/* Broker id selection */}
                        <div style={{ flex: "1 1 150px", minWidth: "250px" }}>
                            <p style={{ margin: 0 }}><b>Select Broker</b></p>
                            <Autocomplete
                                options={brokerMaster}
                                getOptionLabel={(option) => option?.label || ''}
                                value={brokerMaster.find((e: any) => e.value === selectedBrokerId) || null}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedBrokerId: newValue?.value || 0 });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Broker..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                        </div>

                        {/* Template id selection */}
                        <div style={{ flex: "1 1 150px", minWidth: "250px" }}>
                            <p style={{ margin: 0 }}><b>Select Template</b></p>
                            <Autocomplete
                                options={templateMaster}
                                getOptionLabel={(option) => option?.label || ''}
                                value={templateMaster.find((e: any) => e.value === selectedTemplateId) || null}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedTemplateId: newValue?.value || 0 });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Template..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                        </div>

                        {/* LOB id selection */}
                        <div style={{ flex: "1 1 150px", minWidth: "250px" }}>
                            <p style={{ margin: 0 }}><b>Select LOB</b></p>
                            <Autocomplete
                                options={lobMaster}
                                getOptionLabel={(option) => option?.label || ''}
                                value={lobMaster.find((e: any) => e.value === selectedLobId) || null}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedLobId: newValue?.value || 0 });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select LOB..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                        </div>

                        {/* Search button */}
                        <div style={{ flex: "1 1 150px", minWidth: "150px", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    marginTop:"15px",
                                    opacity: selectedBrokerId && selectedTemplateId && selectedLobId ? 1 : 0.5,
                                    pointerEvents: selectedBrokerId && selectedTemplateId && selectedLobId ? "auto" : "none"
                                }}
                                onClick={() => {
                                    this.getQuestionConfig();
                                }}
                                disabled={!(selectedBrokerId && selectedTemplateId && selectedLobId)}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                    {/* Question Config List in Table */}
                    <br />
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: "wrap",
                                gap: "20px",
                                alignItems: "center",
                                justifyContent: "flex-end",
                            }}
                        >
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    opacity: selectedBrokerId && selectedTemplateId && selectedLobId ? 1 : 0.5,
                                    pointerEvents: selectedBrokerId && selectedTemplateId && selectedLobId ? "auto" : "none"
                                }}
                                onClick={() => {
                                    this.handleDialogOpen();
                                }}
                                disabled={!(selectedBrokerId && selectedTemplateId && selectedLobId)}
                            >
                                Add
                            </button>
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    opacity: selectedBrokerId && selectedTemplateId && selectedLobId ? 1 : 0.5,
                                    pointerEvents: selectedBrokerId && selectedTemplateId && selectedLobId ? "auto" : "none"
                                }}
                                onClick={() => {
                                    this.onUpdateClick()
                                }}
                                disabled={!(selectedBrokerId && selectedTemplateId && selectedLobId)}
                            >
                                Update
                            </button>
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                }}
                                onClick={() => this.getQuestionConfig()}
                            >Refresh</button>
                        </div>
                        <br />
                        <div>
                            <Paper sx={{ width: '100%', mb: 2, border: '0.5px solid #7a6e6e54', maxHeight: '60vh' }}>
                                <TableContainer sx={{ maxHeight: 400, overflow: 'auto', paddingBottom: '80px' }}> {/* Enable scrolling */}
                                    <Table stickyHeader sx={{ height: '50px' }} size="small">
                                        {/* Table Header */}
                                        <TableHead>
                                            <TableRow>
                                                {/* Add a header for the checkbox column */}
                                                <TableCell
                                                    sx={{
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        whiteSpace: 'nowrap',
                                                        backgroundColor: '#f5f5f5',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Checkbox
                                                        checked={questionConfigData?.length > 0 && questionConfigData?.every((row) => row.isSelected)}
                                                        indeterminate={
                                                            questionConfigData?.length > 0 ?
                                                                questionConfigData?.some((row) => row.isSelected) &&
                                                                !questionConfigData?.every((row) => row.isSelected) : false
                                                        }
                                                        onChange={(event) => {
                                                            const isChecked = event.target.checked;
                                                            this.setState((prevState) => ({
                                                                questionConfigData: prevState.questionConfigData.map((row) => ({
                                                                    ...row,
                                                                    isSelected: isChecked,
                                                                })),
                                                            }));
                                                        }}
                                                    />
                                                </TableCell>
                                                {columns.map((column) => (
                                                    <TableCell
                                                        key={column.field}
                                                        sx={{
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            whiteSpace: 'nowrap',
                                                            backgroundColor: '#f5f5f5',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        {column.headerName}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        {/* Table Body */}
                                        <TableBody>
                                            {questionConfigData && Array?.isArray(questionConfigData) && questionConfigData?.length > 0 &&
                                                questionConfigData?.map((row) => (
                                                    <TableRow key={row.Id}>
                                                        {/* Render a checkbox in the first column */}
                                                        <TableCell>
                                                            <Checkbox
                                                                checked={row.isSelected || false}
                                                                onChange={(event) => {
                                                                    const isChecked = event.target.checked;
                                                                    this.setState((prevState) => ({
                                                                        questionConfigData: prevState.questionConfigData.map((r) =>
                                                                            r.Id === row.Id ? { ...r, isSelected: isChecked } : r
                                                                        ),
                                                                    }));
                                                                }}
                                                            />
                                                        </TableCell>
                                                        {columns.map((column) => (
                                                            <TableCell
                                                                key={column.field}
                                                                sx={{
                                                                    fontSize: '10px',
                                                                    whiteSpace: 'normal',
                                                                    wordWrap: 'break-word',
                                                                    lineHeight: '1.5',
                                                                }}
                                                            >
                                                                {row.isSelected && column?.field?.toLowerCase() !== "id" &&
                                                                    column?.field?.toLowerCase() !== "isactive" &&
                                                                    column?.field?.toLowerCase() !== "action" ? (
                                                                    <input
                                                                        type="text"
                                                                        value={row[column.field] || ''}
                                                                        onChange={(event) => {
                                                                            const newValue = event.target.value;
                                                                            this.setState((prevState) => ({
                                                                                questionConfigData: prevState.questionConfigData.map((r) =>
                                                                                    r.Id === row.Id ? { ...r, [column.field]: newValue } : r
                                                                                ),
                                                                            }));
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            fontSize: '10px',
                                                                            padding: '4px',
                                                                            boxSizing: 'border-box',
                                                                            border: '1px solid black'
                                                                        }}
                                                                    />
                                                                ) : column.field === 'IsActive' ? (
                                                                    (
                                                                        row[column.field] ? "Active" : "Inactive"
                                                                    )
                                                                ) :
                                                                    column.field === 'Action' ? (
                                                                        <>
                                                                            {
                                                                                row.IsActive ?
                                                                                    <Cancel sx={{ cursor: "pointer" }} onClick={() => this.setState({ iconData: row, confirmDialog: true })} style={{ color: red[500] }} />
                                                                                    :
                                                                                    <CheckIcon sx={{ cursor: "pointer" }} onClick={() => this.setState({ iconData: row, confirmDialog: true })} style={{ color: green[500] }} />
                                                                            }
                                                                        </>
                                                                    )
                                                                        : (
                                                                            row[column.field]
                                                                        )}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </div>
                    </div>
                    {/* Dialog */}
                    <Dialog open={isDialogOpen} onClose={this.handleDialogClose} fullWidth maxWidth="md">
                        <DialogTitle>Add New Question Config</DialogTitle>
                        <DialogContent>
                            <p>Coverage Specification Master</p>
                            <TextField
                                fullWidth
                                margin="normal"
                                value={dialogData.CoverageSpecificationMaster}
                                onChange={(e) => this.handleInputChange('CoverageSpecificationMaster', e.target.value)}
                                InputProps={{
                                    style: {
                                        height: 30,
                                        fontSize: '12px',
                                    },
                                }}
                            />
                            <p>Checklist Questions</p>
                            <TextField
                                fullWidth
                                margin="normal"
                                value={dialogData.ChecklistQuestions}
                                onChange={(e) => this.handleInputChange('ChecklistQuestions', e.target.value)}
                                InputProps={{
                                    style: {
                                        height: 30,
                                        fontSize: '12px',
                                    },
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleDialogClose} color="secondary">
                                Cancel
                            </Button>
                            <Button
                                onClick={this.handleDialogConfirm}
                                color="primary"
                                disabled={!isConfirmEnabled}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    < Dialog open={confirmDialog} onClose={this.handleCloseConfirmDialog} >
                        <DialogContent sx={{
                            padding: '0px 20px',
                            paddingTop: '25px',
                            paddingBottom: '35px',
                            textAlign: 'center',
                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                {iconData ? (
                                    <Box
                                        sx={{
                                            backgroundColor: '#FEE2E2',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Cancel sx={{ color: '#B91C1C', fontSize: 30 }} />
                                    </Box>
                                ) : (
                                    <Box
                                        sx={{
                                            backgroundColor: '#ECFDF5',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <CheckCircle sx={{ color: '#6fd96f', fontSize: 30 }} />
                                    </Box>
                                )}
                            </Box>
                            {/* <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>
                                  Activate/Deactivate User
                                </DialogTitle> */}
                            <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.7)' }}>
                                Are you sure want to {iconData?.IsActive ? 'Deactivate' : 'Activate'} the question.
                            </DialogContentText>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        px: 4,
                                        borderRadius: '6px',
                                    }}
                                    onClick={() => this.handleActivate(iconData)}
                                >
                                    Yes
                                </Button>
                                <Button
                                    onClick={this.handleCloseConfirmDialog}
                                    sx={{
                                        color: '#007bff',
                                        borderColor: '#007bff',
                                        border: '0.5px solid #53494987',
                                        px: 4,
                                        borderRadius: '6px',
                                        '&:hover': {
                                            borderColor: '#0056b3',
                                            color: '#0056b3',
                                        },
                                    }}
                                >
                                    No
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog >
                </GridTable>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert
                        onClose={this.handleCloseSnackbar}
                        severity={snackbarSeverity}
                        sx={{ width: '100%' }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
}

export default QuestionConfigMaster;